@let idBase = 'SdArgumentsComponent_' + currentPage?.toString()?.charAt(0).toUpperCase() + currentPage?.toString()?.slice(1).toLowerCase();
@let pageTemplate = bundle ? 'Bundle' : currentPage;

<div class="product-details-page-template">
  <span [wcCxJsonLd]="snippetsImage"></span>
  <span [wcCxJsonLd]="snippetsVideos"></span>

  @if (bundle) {
    <div>
      <section>
        <wc-bundle-overview
          [showSkeeper]="showSkeeper"
          [objSkeeper]="objSkeeper"
          (hasLoaded)="onOverviewLoaded()"
          [isLoading]="isLoading"
          [bundle]="bundle"
          [isSSR]="isSSR"
          [brand]="brandCorner"
          sdSpyTarget="overview"
        >
          <div pdp-sections>
            @if (!!objSkeeper?.productId && showSkeeper && showRatingAnReviews) {
              <sd-section [title]="reviewTitle" [type]="SectionTypeEnum.REVIEWS">
                <div section-title class="skeepers_product__stars" [attr.data-product-id]="objSkeeper?.productId"></div>
                <div section-modal-content>
                  <p class="is-modal-section-title">{{ reviewTitle }}</p>
                  <ng-container *ngTemplateOutlet="productReviewsBlock" />
                </div>
              </sd-section>
            }
          </div>
        </wc-bundle-overview>
      </section>

      <wc-products-and-bundles [bundle]="bundle" [brand]="brandCorner" />

      <sd-theme-wrapper [brand]="brandCorner">
        <cx-page-slot position="ProductBody" />
      </sd-theme-wrapper>

      @if (showBenefits && bundleArgumentsProductInformation?.content?.heading?.data?.description) {
        <sd-arguments
          sdSpyTarget="presentation"
          [data]="bundleArgumentsProductInformation"
          [themesConfig]="bundleThemesConfigProductInformation"
          [layoutTextConfig]="bundleLayoutTextConfigProductInformation"
          [textConfig]="bundleTextConfigProductInformation"
          [layout]="argumentsLayout"
          [isSmall]="isSmall"
          [brand]="brandCorner"
          [id]="idBase + 'Page_1'"
        />
      }
    </div>
  } @else if (isLoading || product) {

    <span [wcCxJsonLd]="snippetsReviews"></span>

    <div>
      <!-- Lame 1 Overview -->
      <section>
        <wc-product-overview
          sdSpyTarget="overview"
          [showSkeeper]="showSkeeper"
          [objSkeeper]="objSkeeper"
          [product]="product"
          [isSSR]="isSSR"
          [brand]="brandCorner"
          [isLoading]="isLoading"
          (hasLoaded)="onOverviewLoaded()"
        >
          <div pdp-sections>
            @if (shouldRenderWhatsInTheBox()) {
              <!-- Section What's in the box -->
              <sd-section [title]="whatsInTheBoxTitle" [type]="SectionTypeEnum.WHATSINTHEBOX">
                <div section-modal-content>
                  <p class="is-modal-section-title">{{ whatsInTheBoxTitle }}</p>
                  <sd-theme-wrapper [brand]="brandCorner">
                    <cx-page-slot position="WhatsInTheBox" />
                  </sd-theme-wrapper>
                </div>
              </sd-section>
            }

            <!-- Section Comparator / Characteristics -->
            @if (productClassifications && (showBenefits || (currentPage === pdpTypeEnum.IFU))) {
              <sd-section
                [title]="characteristicsTitle" [type]="SectionTypeEnum.CHARACTERISTICS"
                (isOpenedChange)="onSectionModalOpenChange($event)"
              >
                @if (sectionModalIsOpened) {
                  <div section-modal-content>
                    <p class="is-modal-section-title">{{ characteristicsTitle }}</p>
                    <wc-pdp-features
                      sdSpyTarget="characteristics"
                      [brand]="brandCorner"
                      [pageTemplate]="pageTemplate"
                      [isInsideSection]="true"
                    />
                  </div>
                }
              </sd-section>
            }

            @if (!!objSkeeper?.productId && showSkeeper && showRatingAnReviews && product?.gsebNumberOfReviews) {
              <sd-section [title]="reviewTitle" [type]="SectionTypeEnum.REVIEWS">
                <div section-title class="skeepers_product__stars" [attr.data-product-id]="objSkeeper?.productId"></div>
                <div section-modal-content>
                  <p class="is-modal-section-title">{{ reviewTitle }}</p>
                  <ng-container *ngTemplateOutlet="productReviewsBlock" />
                </div>
              </sd-section>
            }
          </div>
        </wc-product-overview>
      </section>

      @if (hasOverviewLoaded) {
        <!-- Lame 2 Bundles -->
        @if (hasProductBundles && (currentPage === pdpTypeEnum.PRODUCT)) {
          <aside>
            <wc-products-and-bundles [product]="product" [brand]="brandCorner" />
          </aside>
        }

        <!-- Cross sell accessoires IFU et FAQ -->
        @if (hasAccessories && (currentPage === pdpTypeEnum.IFU || currentPage === pdpTypeEnum.FAQ)) {
          <section>
            <wc-product-cross-sell
              sdSpyTarget="accessories"
              [productCode]="productCode"
              [pageType]="currentPageType"
              (hasAccessories)="setHasAccessories($event)"
              [previousProductCode]="previousProductCode"
              [brand]="brandCorner"
            />
          </section>
        }

        <!-- Lame 3 Reinsurances -->
        <section>
          <sd-theme-wrapper [brand]="brandCorner">
            @if (this.product.productGenre !== 'Forfait') {
              <cx-page-slot position="ProductBody" />
            }
          </sd-theme-wrapper>
        </section>

        <!-- Lame 4 Arguments (Product info) -->
        @if (showBenefits && argumentsProductInformation?.content?.heading?.data?.description) {
          <section>
            <sd-arguments
              sdSpyTarget="presentation"
              [data]="argumentsProductInformation"
              [themesConfig]="themesConfigProductInformation"
              [layoutTextConfig]="layoutTextConfigProductInformation"
              [textConfig]="textConfigProductInformation"
              [layout]="argumentsLayout"
              [isSmall]="isSmall"
              [brand]="brandCorner"
              [id]="idBase + 'Page_2'"
              [titleLevel]="7"
            />
          </section>
        }

        <!-- Lame 5 Product Benefits -->
        @if (showBenefits && product?.productBenefits?.length > 0) {
          <section>
            <wc-benefits-card-push
              [isProductBenefits]="true"
              [brand]="brandCorner"
              [pageTemplate]="pageTemplate"
            />
          </section>
        }

        <!-- Lame 6 Range -->
        @if (showBenefits && !isRangeEmpty) {
          <aside>
            <wc-product-range (isRangeEmpty)="setIsRangeEmpty($event)" [brand]="brandCorner" />
          </aside>
        }

        <!-- Lame 8 Recipes list -->
        @if (isRecipesEnabled && hasRecipes && !pdpTypeEnum.FAQ && !pdpTypeEnum.IFU) {
          <wc-product-recipe-list
            [productCode]="productCode"
            [brand]="brandCorner"
            (hasRecipes)="setHasRecipes($event)"
          />
        }

        <!-- Lame 10 Arguments (Free Editorial BU) -->
        @if (showBenefits && argumentsFreeEditorialBU?.content?.heading?.data?.description) {
          <section>
            <sd-arguments
              [data]="argumentsFreeEditorialBU"
              [themesConfig]="themesConfigFreeEditorialBU"
              [layoutTextConfig]="layoutTextConfigFreeEditorialBU"
              [textConfig]="textConfigFreeEditorialBU"
              [layout]="argumentsLayout"
              [isSmall]="isSmall"
              [brand]="brandCorner"
              [id]="idBase + 'Page_3'"
            />
          </section>
        }

        <!-- Lame 10.2 Arguments (Free Editorial BU 2) -->
        @if (showBenefits && argumentsFreeEditorialBU2?.content?.heading?.data?.description) {
          <section>
            <sd-arguments
              [data]="argumentsFreeEditorialBU2"
              [themesConfig]="themesConfigFreeEditorialBU2"
              [layoutTextConfig]="layoutTextConfigFreeEditorialBU2"
              [textConfig]="textConfigFreeEditorialBU2"
              [layout]="argumentsLayout"
              [isSmall]="isSmall"
              [brand]="brandCorner"
              [id]="idBase + 'Page_4'"
            />
          </section>
        }

        <!-- Lame 11 Arguments (Free Editorial Local) -->
        @if (showBenefits && argumentsFreeEditorialLocal?.content?.heading?.data?.description) {
          <section>
            <sd-arguments
              [data]="argumentsFreeEditorialLocal"
              [themesConfig]="themesConfigFreeEditorialLocal"
              [layoutTextConfig]="layoutTextConfigFreeEditorialLocal"
              [textConfig]="textConfigFreeEditorialLocal"
              [layout]="argumentsLayout"
              [isSmall]="isSmall"
              [brand]="brandCorner"
              [id]="idBase + 'Page_5'"
            />
          </section>
        }

        <!-- Lame 12 How to -->
        @if (hasProductHowTo && showBenefits) {
          <wc-product-how-to [brand]="brandCorner" />
        }
        @if (currentPage === pdpTypeEnum.PRODUCT) {
          <wc-pdp-comparator />
        }

        <!-- Lame 13 Accessories Cross sell accessoires -->
        @if (hasAccessories && showBenefits) {
          <aside>
            <wc-product-cross-sell
              sdSpyTarget="accessories"
              [productCode]="productCode"
              [pageType]="currentPageType"
              (hasAccessories)="setHasAccessories($event)"
              [previousProductCode]="previousProductCode"
              [isAccessory]="isAccessory"
              [brand]="brandCorner"
            />
          </aside>
        }

        <!-- Lame conçu pour | accessoire -->
        @if (isAccessory && product?.productsDesignedFor?.length > 0) {
          <wc-designed-for
            id="compatibleProduct_hash"
            (hasLoaded)="scrollToHash('compatibleProduct')"
            sdSpyTarget="compatibleProduct"
            [pageTemplate]="currentPage"
          />
        }

        <!-- Lame pieces de rechange -->
        @if (hasReplacementParts && (!isAccessory || isAccessory && previousProductCode)) {
          <section>
            <wc-product-cross-sell
              [productCode]="productCode"
              [pageType]="currentPageType"
              (hasReplacementParts)="setHasReplacementParts($event)"
              [previousProductCode]="previousProductCode"
              [isReplacementParts]="true"
              [brand]="brandCorner"
            />
          </section>
        }

        <!-- Lame Environmental Characteristics -->
        @if (showBenefits || (currentPage === pdpTypeEnum.IFU)) {
          <section>
            <wc-pdp-features
              sdSpyTarget="characteristics"
              [brand]="brandCorner"
              [pageTemplate]="pageTemplate"
            />
          </section>
        }

        <!-- Lame 14 IFU -->
        @if ((currentPage === pdpTypeEnum.IFU) || (showBenefits && hasProductIfu)) {
          <section>
            <wc-ifu-list
              [brand]="brandCorner"
              (hasLoaded)="scrollToHash('ifu-list')"
              [pageTemplate]="pageTemplate"
              id="ifu-list_hash"
            />
          </section>
        }

        <!-- Lame 15 FAQ -->
        @if (hasProductFaqs) {
          <section>
            <wc-product-faqs
              id="block-prod-faq_hash"
              (hasLoaded)="scrollToHash('block-prod-faq')"
              [pdpType]="currentPage"
              [brand]="brandCorner"
            />
          </section>
        }

        <!-- IFU Page FAQ -->
        @if (currentPage === pdpTypeEnum.FAQ && hasProductIfu) {
          <section>
            <wc-ifu-list
              [brand]="brandCorner"
              [pageTemplate]="pageTemplate"
            />
          </section>
        }

        <!-- Lame 16 Application + Arguments -->
        <sd-theme-wrapper [brand]="brandCorner">
          <cx-page-slot position="ApplicationAndArguments" />
        </sd-theme-wrapper>

        <!-- Legal Triman slot before SEO -->
        <sd-theme-wrapper [brand]="brandCorner">
          <cx-page-slot position="Triman" />
        </sd-theme-wrapper>

        <!-- Disclaimer footnote between Triman component and SEO  -->
        @if (!!disclaimerContent && disclaimerContent?.length > 0) {
          <sd-component-wrapper
            [content]="{ footNotes: disclaimerContent }"
            [marginSize]="marginEnum.default_margin"
            [themesConfig]="lameConfig?.disclaimer?.backgroundTheme"
            [brand]="brandCorner"
          />
        }
        <sd-theme-wrapper [brand]="brandCorner">
          <cx-page-slot position="SEO" />
        </sd-theme-wrapper>
      }
    </div>
  }

  <ng-template #productReviewsBlock>
    @if (!!objSkeeper?.productId && showSkeeper && showRatingAnReviews) {
      <wc-product-reviews
        id="block-product-reviews"
        [objSkeeper]="objSkeeper"
        [brand]="brandCorner"
        [pageTemplate]="pageTemplate"
      />
    }
  </ng-template>
</div>
